import apiSlice from './ApiSlice';

export const communicationMethodApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({  

    // Get CommunicationMethod Filter Pagination List
    getCommunicationMethodPagination: builder.query({
      providesTags: ["communication-method"],
      query: (body) => {
        return {
          url: "/communication-method",
          method: "POST",
          body,
        };
      },
    }),
     // GET ALL
     getAllCommunicationMethod: builder.query({
      providesTags: ["communication-method"],
      query: () => {
        return {
          url: "/communication-method",
          method: "GET",
        };
      },
    }),

    // ADD
    addCommunicationMethod: builder.mutation({ 
      invalidatesTags: ["communication-method"],
      query: (body) => {
        return {
          url: "/communication-method/add",
          method: "POST",
          body,
        };
      },
    }), 
     // EDIT
     editCommunicationMethod: builder.mutation({
      invalidatesTags: ["communication-method"],
      query: ({ body, id }) => {
        return {
          url: `/communication-method/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    // GET SINGLE CommunicationMethod
    getCommunicationMethod: builder.query({
      providesTags: ["communication-method"],
      query: ({ id }: { id: string }) => {
        return {
          url: `/communication-method/${id}`,
          method: "GET",
        };
      },
    }),
    // DELETE
    deleteCommunicationMethod: builder.mutation({
      invalidatesTags: ["communication-method"],
      query: ({ id }: { id: string }) => {
        return {
          url: `/communication-method/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {useAddCommunicationMethodMutation , useGetAllCommunicationMethodQuery , useGetCommunicationMethodPaginationQuery , useDeleteCommunicationMethodMutation , useEditCommunicationMethodMutation , useGetCommunicationMethodQuery } = communicationMethodApi;